import { Card, CardContent } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { API_URL } from "@/lib/api";

export default function FilesTab({ files }) {
  return (
    <Card className="mt-4 border-black/5">
      <CardContent className="p-4 space-y-2">
        {files.map((f) => (
          <div key={f.file_id} className="flex items-center gap-3 border border-black/5 rounded-md p-3" data-testid={`admin-file-${f.file_id}`}>
            <FileText className="h-4 w-4 text-[color:var(--orange)]" />
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{f.original_filename}</div>
              <div className="text-xs text-[color:var(--text-secondary)]">{f.email} · {new Date(f.uploaded_at).toLocaleString()}</div>
            </div>
            <Badge variant="outline" className="border-black/10 text-xs">{f.category}</Badge>
            <a href={`${API_URL}/files/${f.file_id}/download`} target="_blank" rel="noopener noreferrer" data-testid={`admin-file-download-${f.file_id}`}>
              <Button size="sm" variant="outline" className="border-black/10">Download</Button>
            </a>
          </div>
        ))}
        {files.length === 0 && <p className="text-sm text-[color:var(--text-secondary)]">No uploads yet.</p>}
      </CardContent>
    </Card>
  );
}
